import React from 'react'

const QuotationViewPage = () => {
  return (
    <div>ProformaInvoiceViewPage</div>
  )
}

export default QuotationViewPage